import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RateReviewIcon from '@material-ui/icons/RateReview';
import Section from './Section';
import FeedbacksList, { useHasReviews } from './FeedbacksList';

const useStyles = makeStyles((theme) => ({
  actions: {
    textAlign: 'center',
    marginTop: theme.spacing(6),
  },
}));

// Only shown once at least one review has been approved in the admin page.
export default function Testimonials({ onLeaveReview }) {
  const classes = useStyles();
  const hasReviews = useHasReviews();

  if (!hasReviews) return null;

  return (
    <Section
      id="reviews"
      background="sand"
      eyebrow="Reviews"
      title="What our customers say"
      subtitle="We value your business and appreciate every review as we keep working to give you an excellent experience."
    >
      <FeedbacksList />
      <div className={classes.actions}>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          startIcon={<RateReviewIcon />}
          onClick={onLeaveReview}
        >
          Leave a review
        </Button>
      </div>
    </Section>
  );
}
